export default "__VITE_ASSET__Dl0tJ41w__";